import script from "./AdmissionTicket.vue?vue&type=script&setup=true&lang=js"
export * from "./AdmissionTicket.vue?vue&type=script&setup=true&lang=js"

import "./AdmissionTicket.vue?vue&type=style&index=0&id=6f710a75&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f710a75"]])

export default __exports__